<template>
 <div >
  <img src="../assets/22.jpg" style="height:350px;width:100%;" alt=""  />
  <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb1">
    <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item :to="{ path: '/active/1' }">公司动态</el-breadcrumb-item>
    <el-breadcrumb-item>动态详情</el-breadcrumb-item>
  </el-breadcrumb>
  
  <Intro3></Intro3>
  

 </div>
</template>

<script>
import Cardshow1 from '../components/cardshow1.vue'
import Intro3 from '../components/intro3.vue'
import bus from '../assets/bus.js'

export default {
 components:{

  Cardshow1,
  Intro3,
  bus
  
 
 },
 data() {
      return {
        id:19,
        articlelist:[],
        queryInfo: {
        title: '',
        type: '基金报告',
        pagenum: '',
        pagesize: '',
      },
      };
    },
    created(){
      // bus.$on('data',data=>{this.page = data;});


    },
    mounted(){
    
  },
    
    methods: {
      
      // async getarticlelist(){
      //   const res =await this.$http.get('/huayin/get-articles',{params:this.queryInfo}
      //     )
      //   this.articlelist=res.data.data
      //   console.log(this.articlelist[0].id)
      //   bus.$emit('data',this.articlelist[0].content)
      //   bus.$emit('data1',this.articlelist[0].title)


      // }
    },

}
</script>


<style>
    
    .text {
    font-size: 14px;
    color: white;
  }

  .item {
    margin-bottom: 25px;
  }
  .text a{
    text-decoration: none;
    color:aliceblue;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  #box-card1 {
    width: 220px;
    height: 600px;
    background-color:#572d2d;
    position: absolute;
    margin-top: -100px;
    margin-left: 100px;
    z-index: 9999;
  }
  .control-center{
    text-align: center;
  }
  .breadcrumb1{
      font-size: 18px;
      margin-top: 40px;
      margin-bottom: 40px;
      margin-left: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/fund-1.vue